import { render, staticRenderFns } from "./DefaultSignup.vue?vue&type=template&id=0e4a9952&lang=pug&"
import script from "./DefaultSignup.vue?vue&type=script&lang=ts&"
export * from "./DefaultSignup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports